module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header",
    attrs: {
      "title": _vm.data.title
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  }), _vm._v(" "), _c('mu-icon-menu', {
    attrs: {
      "icon": "more_vert"
    },
    slot: "right"
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "顶部",
      "href": "#content-tip"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "评论区",
      "href": "#comments-main"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "写评论",
      "href": "#comments-input"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "返回首页",
      "to": "/vue-home/dist"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "content-tip"
    }
  }, [(_vm.data.top) ? _c('span', [_vm._v("置顶")]) : (_vm.data.good) ? _c('span', [_vm._v("精华")]) : (_vm.data.tab === 'share') ? _c('span', {
    style: (_vm.styleObj)
  }, [_vm._v("分享")]) : (_vm.data.tab === 'ask') ? _c('span', {
    style: (_vm.styleObj)
  }, [_vm._v("问答")]) : (_vm.data.tab === 'job') ? _c('span', {
    style: (_vm.styleObj)
  }, [_vm._v("招聘")]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("  " + _vm._s(_vm.data.title) + "  ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-about"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/vue-home/dist/people',
        query: {
          user: _vm.data.author.loginname
        }
      },
      "alt": "user"
    }
  }, [(_vm.data.author) ? _c('img', {
    staticClass: "content-author-pic",
    attrs: {
      "src": _vm.data.author.avatar_url
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("作者：" + _vm._s(_vm.data.author.loginname))]), _vm._v(" "), _c('span', [_vm._v("发表时间：" + _vm._s(_vm._f("formatDate")(_vm.data.create_at)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("最后回复：" + _vm._s(_vm._f("formatDate")(_vm.data.last_reply_at)))]), _vm._v(" "), _c('span', [_vm._v("浏览量：" + _vm._s(_vm.data.visit_count))])], 1), _vm._v(" "), _c('div', {
    staticClass: "collect"
  }, [(_vm.accesstoken) ? _c('mu-checkbox', {
    staticClass: "demo-checkbox",
    attrs: {
      "label": _vm.collectText,
      "uncheckIcon": "favorite_border",
      "checkedIcon": "favorite"
    },
    model: {
      value: (_vm.collect),
      callback: function($$v) {
        _vm.collect = $$v
      },
      expression: "collect"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-text",
    domProps: {
      "innerHTML": _vm._s(_vm.data.content)
    }
  }), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "comments-main"
    }
  }, [_c('li', {
    staticClass: "comments-num"
  }, [_vm._v(_vm._s(_vm.data.replies.length) + "条评论")]), _vm._v(" "), _vm._l((_vm.data.replies), function(list, index) {
    return _c('li', {
      key: list.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/vue-home/dist/people',
          query: {
            user: list.author.loginname
          }
        },
        "alt": "user"
      }
    }, [(list.author) ? _c('img', {
      attrs: {
        "src": list.author.avatar_url
      }
    }) : _vm._e()]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(list.author.loginname))]), _vm._v(" "), _c('span', {
      staticClass: "comments-peopele-ups"
    }, [_c('mu-icon', {
      attrs: {
        "value": "thumb_up",
        "size": 16,
        "color": "#a9a9a9"
      },
      on: {
        "click": function($event) {
          _vm.good(index)
        }
      }
    }), _vm._v(_vm._s(list.ups.length) + "\n                                      ")], 1), _vm._v(" "), _c('span', {
      staticClass: "comments-peopele-time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(list.create_at)))]), _c('br'), _vm._v(" "), _c('mu-icon', {
      staticClass: "textsms",
      attrs: {
        "value": "textsms",
        "size": 16,
        "color": "#a9a9a9"
      },
      on: {
        "click": function($event) {
          _vm.commentReply(index)
        }
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(list.content)
      }
    }), _vm._v(" "), (_vm.accesstoken) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (list.reply_show),
        expression: "list.reply_show"
      }],
      staticClass: "comment-reply"
    }, [_c('mu-text-field', {
      staticClass: "comment-reply-text",
      attrs: {
        "hintText": "请输入评论",
        "multiLine": "",
        "rows": 2,
        "rowsMax": 6,
        "fullWidth": ""
      },
      model: {
        value: (_vm.commentReplyText),
        callback: function($$v) {
          _vm.commentReplyText = $$v
        },
        expression: "commentReplyText"
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "demo-raised-button ",
      attrs: {
        "label": "确认",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.commentReplyOn(index)
        }
      }
    }), _vm._v(" "), _c('mu-raised-button', {
      staticClass: "demo-raised-button ",
      attrs: {
        "label": "取消",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.commentReplyOf(index)
        }
      }
    })], 1) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "comments-input"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": "这里输入评论内容",
      "multiLine": "",
      "rows": 3,
      "rowsMax": 6
    },
    model: {
      value: (_vm.commentText),
      callback: function($$v) {
        _vm.commentText = $$v
      },
      expression: "commentText"
    }
  }), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "评论",
      "primary": ""
    },
    on: {
      "click": _vm.commentOn
    }
  })], 1), _vm._v(" "), (!_vm.accesstoken) ? _c('mu-toast', {
    attrs: {
      "message": "点赞评论及收藏文章请先登录"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.commentSuccess) ? _c('mu-toast', {
    attrs: {
      "message": "评论成功！！"
    },
    on: {
      "close": function($event) {
        _vm.commentReplyOf(_vm.index)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.commentFalse) ? _c('mu-toast', {
    attrs: {
      "message": "评论失败！！"
    },
    on: {
      "close": function($event) {
        _vm.commentReplyOf(_vm.index)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a70ae48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/content.vue
// module id = 141
// module chunks = 1